import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { take } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DateTime } from 'luxon';
import { ReferentielsService } from 'src/app/core/services/referentiels.service';
import { Elements } from '@models/domains/administration';

@Component({
    selector: 'app-detail-annuaire-poste',
    imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatDialogModule,
    DragDropModule
],
    templateUrl: './detail-annuaire-poste.component.html',
    styleUrls: ['./detail-annuaire-poste.component.scss']
})
export class DetailAnnuairePosteComponent {
  dialogRef: any;
  dataJSON: any[] = [];
  rowData: any;
  dateP = new DatePipe('fr-FR');
  totalLigne: any = '';
  afficheTable: any = null;
  type: string = '';
  typeContratList: any[] = [];
  tableColumns: string[] = ['Nom', 'Fonction', 'Age', 'Type contrat', 'Début fin contrat', 'Taux emploi'];
  dataSource: any[] = [];
  astrainteDataSource: any[] = [];
  hasAgents: boolean = false;

  constructor(
    private ref: MatDialogRef<DetailAnnuairePosteComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly referentielsService: ReferentielsService,
    private detectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.transformData();
    this.loadListTypeContrat();
    // this.rowData = this.data;
  }

  closepopup() {
    this.ref.close();
  }
  fermerdialog() {
    this.ref.close();
  }

  transformData() {
    const detenteurs = Array.isArray(this.data?.detenteurs) ? this.data.detenteurs : [];

    this.hasAgents = detenteurs.length > 0;
    this.afficheTable = this.hasAgents;

    if (!this.hasAgents) {
      this.dataSource = [];
      return;
    }

    const mappedDetenteurs = detenteurs.map((agent: any) => {
      let type_contrat = agent?.typeContrat || null;

      // calcul de l'âge d'après la date de naissance
      let ageDetenteur = '';
      if (agent?.dateNaissance) {
        let dateDebut = DateTime.fromISO(agent?.dateNaissance).setLocale('fr');
        let dateFin = DateTime.fromJSDate(new Date()).setLocale('fr');
        ageDetenteur = dateFin.diff(dateDebut, ['years', 'months', 'days', 'hours']).years + '';
      }
      return {
        nom: `${agent?.nom || ''} ${agent?.prenom || ''}`.trim(),
        fonction: agent?.fonction,
        age: ageDetenteur,
        taux_emploi: `${agent?.tauxEmploi || ''}`,
        type_contrat: this.getTypeContratLabel(type_contrat) ?? null,
        debut_fin_contrat:
          agent?.dateDebutContrat && agent?.dateFinContrat
            ? this.formatDate(agent.dateDebutContrat) + ' - ' + this.formatDate(agent.dateFinContrat)
            : ''
      };
    });

    this.dataSource = mappedDetenteurs;

  }

  formatDate(date: string) {
    const ma_date = DateTime.fromISO(date);
    return ma_date.isValid ? ma_date.toFormat('dd/MM/yyyy') : '';
  }

  loadListTypeContrat() {
    this.referentielsService
      .getTypeContrat()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.typeContratList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }

        this.transformData();
      });
  }

  getTypeContratLabel(id: number): string {

    const typeContrat = this.typeContratList.find((t) => t.id === id);
    return typeContrat ? typeContrat.libelle : '';
  }
}
